// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1GD_1","inner":"Form_inner__14cA1","range":"Form_range__1yxyG","name":"Form_name__Im44k","actions":"Form_actions__1Fy4Q"};